<div class="header d-flex">
    <div class="dashboard-name">{{dashboard?.DashboardName ? dashboard.DashboardName : ''}}</div>
</div>

<div class="body">
    <cv-responsive-dashboard *ngIf="dashboard !== null" class="w-100 h-100" [dashboardInfo]="dashboard"></cv-responsive-dashboard>
    <div *ngIf="dashboard === null && !loadingDashboard" class="removed-url" cvLocalizedText langSection="Share_URL" langKey="Removed_URL">URL has been removed</div>
</div>
